// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkDiscoverySourceTypeSchema } from '../inputTypeSchemas/ExternalNetworkDiscoverySourceTypeSchema'
import { ExternalNetworkReachabilityStatusSchema } from '../inputTypeSchemas/ExternalNetworkReachabilityStatusSchema'

/////////////////////////////////////////
// HOST SCHEMA
/////////////////////////////////////////

/**
 * Network-reachable IP-based asset. Lives under a NetBlock.
 * `resolvedDomainIds` denormalizes the M:N "domains whose forward DNS targets this IP".
 */
export const HostSchema = z.object({
  sourceType: ExternalNetworkDiscoverySourceTypeSchema.nullable(),
  reachabilityStatus: ExternalNetworkReachabilityStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  netblockId: z.string(),
  ipAddress: z.string(),
  hostnames: z.string().array(),
  resolvedDomainIds: z.string().array(),
  cloudProvider: z.string().nullable(),
  classification: z.string().nullable(),
  classificationConfidence: z.number().int().nullable(),
  lastReachabilityCheckedAt: z.coerce.date().nullable(),
  lastReachableAt: z.coerce.date().nullable(),
  lastUnreachableAt: z.coerce.date().nullable(),
  vhostEnumCompletedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Host = z.infer<typeof HostSchema>

export default HostSchema;
